import React from 'react';
import PropTypes from 'prop-types';

import {
  Header,
  Footer,
} from 'components';

class HFBlock extends React.PureComponent {
  render () {
    const {
      locale,
      children,
      location,
      className,
      localeCode,
      match: { params }
    } = this.props;
    return (
      <div className={className}>
        <Header {...{localeCode, locale, location, params}} />
        {children}
        <Footer {...{locale, location, params}} />
      </div>
    );
  }
}

export default HFBlock;

HFBlock.propTypes = {
  locale: PropTypes.string,
  location: PropTypes.object,
  className: PropTypes.string,
};

HFBlock.defaultProps = {
  locale: "",
  className: "",
};



// WEBPACK FOOTER //
// ./src/components/HFBlock.js